import React, { Component } from 'react'
import Spinner from 'react-bootstrap/Spinner'
import contactAnimationData from '../helper/empty.json'
import Lottie from 'react-lottie';

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: contactAnimationData,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};

export default class EmptyComponent extends Component {
    render() {
        return (
            <div style={{
                alignSelf: 'center',
                flexDirection: "column",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding:"10rem 0 0 0 "
            }}>
                <Lottie options={defaultOptions} width={200} />
            </div>
        )
    }
}
